import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ClothesRackIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ClothesRackIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.7267 2.72888C21.4266 2.72888 21.1834 2.97214 21.1834 3.2722V5.05669H14.5592V5.01807C14.5325 4.29797 13.499 4.29851 13.4726 5.01807V5.05669H11.0675V5.01807C11.0408 4.29797 10.0073 4.29851 9.98086 5.01807V5.05669H3.35665V3.2722C3.32992 2.55209 2.2965 2.55263 2.27002 3.2722V20.7307C2.29675 21.4508 3.33017 21.4502 3.35665 20.7307V6.14328H9.98086V7.38446H7.61444C7.47032 7.38446 7.33217 7.44172 7.23028 7.54361L5.48443 9.28946C5.27399 9.49179 5.27399 9.85552 5.48443 10.0578L7.07116 11.6445V16.657C7.07116 16.9571 7.31441 17.2004 7.61447 17.2004H16.9256C17.2257 17.2004 17.469 16.9571 17.469 16.657V11.6445L19.0557 10.0578C19.2662 9.85544 19.2661 9.49175 19.0557 9.28942L17.3098 7.54357C17.208 7.44168 17.0698 7.38442 16.9257 7.38442H14.5592V6.14327H21.1834V20.7306C21.2101 21.4507 22.2435 21.4502 22.27 20.7306V3.27216C22.27 2.9721 22.0268 2.72888 21.7267 2.72888ZM11.0675 6.14328H13.4725V7.38446H11.0675V6.14328ZM9.90359 8.47109H11.1448V9.09166C11.1135 9.91402 9.93459 9.91341 9.90359 9.09166V8.47109ZM12.8906 11.4195V16.1137H8.15775V11.4195C8.15775 11.2754 8.10049 11.1372 7.99859 11.0353L6.63694 9.67365L7.83947 8.47112H8.81693V9.09169C8.90303 11.354 12.1461 11.3523 12.2314 9.09169V8.47112H13.2089L14.4114 9.67365L13.0498 11.0353C12.9479 11.1372 12.8906 11.2754 12.8906 11.4195ZM16.7005 8.47109L17.9031 9.67362L16.5414 11.0353C16.4395 11.1372 16.3822 11.2754 16.3822 11.4194V16.1137H13.9772V11.6445L15.5639 10.0578C15.7761 9.8456 15.7761 9.50161 15.5639 9.28943L14.7456 8.47106L16.7005 8.47109Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ClothesRackIcon;
